import React from 'react';
import { Box } from '@mui/material';
import PortalLayoutHeader from './PortalLayoutHeader';
import PortalNavList from './PortalNavList';
import ResponsiveSidebar from './ResponsiveSidebar';
import SidebarBrand from './SidebarBrand';
import { PortalHeaderProvider } from './PortalPageHeader';
import { useMobileNavOpen } from './useMobileNavOpen';
import { usePortalTokens } from '../../styles/usePortalTokens';

const PortalShell = ({
  navItems,
  user,
  notificationsPath,
  onSignOut,
  signOutRedirectPath,
  children,
  overlay = null,
}) => {
  const { mobileNavOpen, openMobileNav, closeMobileNav } = useMobileNavOpen();
  const portal = usePortalTokens();

  return (
    <PortalHeaderProvider>
      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          bgcolor: portal.sidebarBg,
          overflow: 'hidden',
        }}
      >
        <ResponsiveSidebar mobileOpen={mobileNavOpen} onMobileClose={closeMobileNav}>
          <SidebarBrand />
          <PortalNavList items={navItems} onNavigate={closeMobileNav} />
        </ResponsiveSidebar>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            bgcolor: portal.pageBg,
          }}
        >
          <PortalLayoutHeader
            user={user}
            notificationsPath={notificationsPath}
            onSignOut={onSignOut}
            signOutRedirectPath={signOutRedirectPath}
            onMenuOpen={openMobileNav}
          />
          <Box
            component="main"
            sx={{
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              overflow: 'auto',
              px: { xs: 2, sm: 3, md: 4 },
              pb: { xs: 3, md: 7.5 },
            }}
          >
            {children}
          </Box>
        </Box>
        {overlay}
      </Box>
    </PortalHeaderProvider>
  );
};

export default PortalShell;
